module.exports = "//docs.gtimg.com/slide/img/framework/frame-pc/components/palette-panel/images/more-setting-a94f47.svg";